import * as XLSX from "xlsx";
import Moment from "moment";
import { format } from "date-fns";
import { translateStatesfalabbela } from "../objects/translateStates";

// Función auxiliar para extraer la fecha segura desde Firestore Timestamp o JSON
const getDateFormatted = (timestamp) => {
  try {
    const seconds = timestamp?.seconds ?? timestamp?._seconds;
    return seconds ? format(new Date(seconds * 1000), "dd/MM/yy HH:mm:ss") : "";
  } catch {
    return "";
  }
};

const generarReporteDiscrepanciasPiking = async (
  data,
  ridersDataByCompany,
  initDate
) => {
  async function addDataRidersDataByCompany(data) {
    const filterPiker = data.filter((item) => item.isPickedUp !== true);
    const newData = JSON.parse(JSON.stringify(filterPiker));

    let currentDate = new Date(initDate);
    let year = currentDate.getFullYear().toString().slice(-2);
    let month = String(currentDate.getMonth() + 1).padStart(2, "0");
    let day = String(currentDate.getDate()).padStart(2, "0");
    let formattedDate = year + month + day;

    const matrizReporte = [
      [
        "LPN",
        "Suborden",
        "F12",
        "PPU",
        "Origen de Carga",
        "Tipo de Servicio",
        "ID Ruta/Viaje/Shipment",
        "Fecha de recepción",
        "Fecha de carga",
        "Fecha de entrega",
        "Estado",
        "Motivo de no entrega",
        "Receptor",
        "RUT Receptor",
        "Observación",
        "fotos",
      ],
      ...newData.map((dato) => [
        dato.lpn || dato.int_lpn,
        dato.id,
        dato.do || dato.int_f12,
        dato.ppu || dato.driverLicensePlate,
        dato.local_provider || dato.int_warehouseName,
        dato.local_provider || dato.dataOrigin === "SDDATA"
          ? "PPF"
          : "CTT BICCI",
        dato.idRoute || dato.routeId,

        // Fecha de recepción
        getDateFormatted(dato.date) || dato.routeStartDate,

        // Fecha de carga
        getDateFormatted(dato.date) || dato.routeEstimatedDate,

        // Fecha de entrega
        getDateFormatted(dato.deliveryRealDeliveryDate || dato.upDatedAtText),

        // Estado
        dato.falabella_status
          ? translateStatesfalabbela[dato.falabella_status]
          : dato.int_falabella_status === "Terminado" ||
            dato.int_bicciStatus === 8
          ? "Entregado"
          : "Pendiente",

        // Motivo de no entrega
        dato.falabella_status
          ? dato.falabella_status === "99" &&
            dato.falabella_status !== "isRequire"
            ? ""
            : translateStatesfalabbela[dato.falabella_status]
          : dato.int_falabella_status === "Terminado" ||
            dato.int_falabella_status === "99" ||
            dato.int_bicciStatus === 8
          ? ""
          : dato.int_falabella_status_descriptor !== "isRequire"
          ? dato.int_falabella_status_descriptor
          : translateStatesfalabbela[dato.int_falabella_status],

        dato.userNameReceptor || dato.deliveryReceptor,
        dato.userDniReceptor || dato.deliveryRut,

        // Observación combinada
        dato.observationReceptor ||
        dato.observationAdmin ||
        dato.deliveryComment
          ? `${
              dato.observationAdmin
                ? `- Operador:  ${dato.observationAdmin[0]} `
                : ""
            }${
              dato.observationReceptor
                ? `- Conductor: ${dato.observationReceptor}`
                : ""
            }${dato.deliveryComment ? `- ${dato.deliveryComment}` : ""}`
          : null,

        // Fotos
        dato.pics && dato.pics.length > 0 ? dato.pics.join("\n") : "",
      ]),
    ];

    const libro = XLSX.utils.book_new();
    const hoja = XLSX.utils.aoa_to_sheet(matrizReporte);
    XLSX.utils.book_append_sheet(libro, hoja, "Reporte");

    XLSX.writeFile(
      libro,
      `Reporte de discrepancias folios sin lectura de físico ${Moment().format(
        "YYYY-MM-DD"
      )}.xlsx`
    );
  }

  await addDataRidersDataByCompany(data, ridersDataByCompany);
};

export default generarReporteDiscrepanciasPiking;
